<template>
  <v-flex>
    <v-layout row mt-1>
      <v-btn @click="getLocations">get Locations</v-btn>
      <v-btn @click="getTours">get Tours</v-btn>
      <v-btn @click="getRelays">get Relays</v-btn>
      <v-btn @click="getEvents">get Events</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select :items="items" label="Runtime" v-model="getCalendarModel"></v-select>
      </v-flex>
      <v-btn @click="getCalendar">get Calendar</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="getEventDetailsModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="getEventDetails">get Event Details</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="finishTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="finishTrip">finish trip</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="cancelOrderTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="cancelOrder">Cancel order</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="deleteTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="deleteTrip">deleteTrip</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="newTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="newTrip">new Trip</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="getFullTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="getFullTrip">get Full Trip</v-btn>
      <v-layout row mt-1>TripId: {{tripId}}</v-layout>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="getSuggestionsModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="getSuggestions">get Suggestions</v-btn>
      <v-layout
        row
        mt-1
        v-if="showSuggestion"
      >Suggestion: {{Object.keys(this.suggestion)[0]}} - {{this.suggestion[Object.keys(this.suggestion)[0]].Name}}</v-layout>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="bookActivityModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="bookActivity">book Activity</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="acceptTripModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="acceptTrip">accept Trip</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="getThemesModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="getThemes">retrieve the themes</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="confirmOrderModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="confirmOrder">confirm Order</v-btn>
      <v-layout row mt-1>OrderId: {{orderId}}</v-layout>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="getListOfTripsModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="getListOfTrips">get List Of Trips</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="arrivedAtEventModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="arrivedAtEvent">arrived At Event</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="leftFromEventModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="leftFromEvent">left From Event</v-btn>
    </v-layout>
    <v-layout row mt-1>
      <v-flex xs2>
        <v-select v-model="updateLocationModel" :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-btn @click="updateLocation">update location</v-btn>
    </v-layout>
    <v-layout row mt-1>Number of booked suggestions: {{this.bookedSuggestions}}</v-layout>
    <v-layout row mt-1>
      <v-flex>
        <v-text-field
          v-model="startDate"
          auto-grow
          class="mb-2"
          label="StartDate"
          hint="dd-mm-yyyy"
          outline
        />
      </v-flex>
      <v-flex>
        <v-text-field
          v-model="endDate"
          auto-grow
          class="mb-2"
          label="EndDate"
          hint="dd-mm-yyyy"
          outline
        />
      </v-flex>
      <v-flex>
        <v-select v-model="getBookedSuggestionsModel" outline :items="items" label="Runtime"></v-select>
      </v-flex>
      <v-flex>
        <v-btn @click="getBookedSuggestions">get Booked Suggestions</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row mt-1>
      <v-flex>
        <v-text-field v-model="eventIdGetBatches" auto-grow class="mb-2" label="EventId" outline />
      </v-flex>
      <v-flex>
        <v-btn @click="getBatches()">getBatch</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row mt-1>
      <v-flex>
        <v-text-field v-model="deliveryKey" auto-grow class="mb-2" label="Delivery key" outline />
      </v-flex>
      <v-flex>
        <v-btn @click="getOrders()">getOrders</v-btn>
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="batchesDialog" width="800">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>All batches</v-card-title>
          <v-layout column>
            <template v-for="(item,index) in allBatches">
              <v-card>
                <v-layout row>
                  <h3>StartTime: {{item.StartTime}} - EndTime: {{item.EndTime}} - BatchGroupId: {{item.BatchGroupId}}</h3>
                  <v-checkbox class="checkbox" v-model="item.Selected"></v-checkbox>
                </v-layout>
              </v-card>
            </template>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="sortTheBatches()">I accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-flex>
</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";

export default {
  data() {
    return {
      //Heinrich var
      deliveryKey: "",
      selectedBatches: [],
      allBatches: {},
      batchesDialog: false,
      eventIdGetBatches: "",
      cancelOrderTripModel: "",
      getCalendarModel: "",
      getEventDetailsModel: "",
      getThemesModel: "",
      newTripModel: "",
      getFullTripModel: "",
      getSuggestionsModel: "",
      bookActivityModel: "",
      acceptTripModel: "",
      confirmOrderModel: "",
      getListOfTripsModel: "",
      arrivedAtEventModel: "",
      leftFromEventModel: "",
      getBookedSuggestionsModel: "",
      finishTripModel: "",
      cancelOrderModel: "",
      deleteTripModel: "",
      updateLocationModel: "",

      showSuggestion: false,
      tripId: "-",
      orderId: "-",
      suggestion: {},
      bookedSuggestions: 0,
      startDate: "",
      endDate: "",
      items: [true, false, "Empty"],

      increment: 0.0003
    };
  },

  watch: {
    suggestion: function(newV, oldV) {
      if (newV != oldV && newV != null) {
        this.showSuggestion = true;
      } else if (newV != oldV) {
        this.showSuggestion = true;
      }
    }
  },

  methods: {
    sortTheBatches() {
      const tickets = {};
      this.selectedBatches = [];
      for (let [index, item] of Object.entries(this.allBatches)) {
        if (item.Selected) {
          for (let [innerIndex, innerItem] of Object.entries(
            item.PriceCategories
          )) {
            Object.assign(tickets, {
              [innerItem.Id]: 1
            });
          }
          this.selectedBatches.push(item);
        }
      }
      this.bookBatch(tickets);
    },
    bookBatch(tickets){
      const payload = {
        StartDate: "22-03-2020",
        EventId: Number(this.eventIdGetBatches),
        BatchId: this.selectedBatches[0].BatchGroupId,
        EndBatchId: this.selectedBatches[this.selectedBatches.length - 1]
          .BatchGroupId,
        Tickets: tickets
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call bookBatch was successful", response);
        },
        error => {
          console.log("The generic call bookBatch was not successful", error);
        },
        "bookBatch",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getOrders() {
      let today = new Date();
      let date = today.getDate()+'-'+(today.getMonth()+1)+'-'+ today.getFullYear();
      const payload = {
        Day: date,
        DeliveryKey: this.deliveryKey != "" ? this.deliveryKey : "None"
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getOrders was successful", response);
        },
        error => {
          console.log("The generic call getOrders was not successful", error);
        },
        "getOrders",
        this.$store.getters.getCurrentAccountId + "_UG_" + "377",
        payload
      );
    },
    getBatches() {
      const payload = {
        StartDate: "22-03-2020",
        EndDate: "22-04-2020",
        StartTime: "00:00",
        EndTime: "23:59"
      };
      dssRequest.doRequest(
        response => {
          for (let [index, item] of Object.entries(response.data.Batches)) {
            item.Selected = false;
          }
          console.log("The generic call getBatches was successful", response);
          this.batchesDialog = true;
          this.allBatches = response.data.Batches;
        },
        error => {
          console.log("The generic call getBatches was not successful", error);
        },
        "getBatches",
        Number(this.eventIdGetBatches),
        payload
      );
    },
    getThemes() {
      const object = "";
      const payload = {};
      if (this.$store.getters["auth/partnerId"] > 0) {
        this.object = this.$store.getters["auth/partnerId"];
      } else {
        this.object = this.$store.getters.getCurrentAccountId;
      }

      dssRequest.doRequest(
        response => {
          console.log("The generic call getThemes successful", response);
        },
        error => {
          console.log("The generic call getThemes was not successful", error);
        },
        "getThemesV2",
        object,
        payload
      );
    },
    loop() {
      this.x = !this.x;
      while (this.x === false) {
        this.getCalendar();
      }
    },
    getLocations() {
      let payload = {};
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getLocations was successful", response);
        },
        error => {
          console.log("the call for getLocations was not successful", error);
        },
        "getLocationsV2",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    getTours() {
      let payload = {};
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getTours was successful", response);
        },
        error => {
          console.log("the call for getTours was not successful", error);
        },
        "getTours",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    getRelays() {
      let payload = {};
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getRelays was successful", response);
        },
        error => {
          console.log("the call for getRelays was not successful", error);
        },
        "getRelays",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    getEvents() {
      let payload = {
        AccountId: this.$store.getters.getCurrentAccountId,
        UserId: "",
        PartnerId: this.$store.getters.PartnerId,
        LanguageTagId: 13
      };
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getRelays was successful", response);
        },
        error => {
          console.log("the call for getRelays was not successful", error);
        },
        "getEventsV2",
        "LocationsNode_EAM",
        payload
      );
    },
    getCalendar() {
      let payload = {};
      if (this.getCalendarModel == "Empty") {
        payload = {
          StartDate: "11-12-2019",
          LanguageTagId: 13
        };
      } else {
        payload = {
          Runtime: this.getCalendarModel,
          StartDate: "11-12-2019",
          LanguageTagId: 13
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getCalendar was successful", response);
        },
        error => {
          console.log("the call for getCalendar was not successful", error);
        },
        "getCalendar",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getEventDetails() {
      let payload = {};
      if (this.getEventDetailsModel == "Empty") {
        payload = {
          Runtime: this.getEventDetailsModel,
          LanguageTagId: 13
        };
      } else {
        payload = {
          LanguageTagId: 13
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getEventDetails was successful", response);
        },
        error => {
          console.log(
            "the call for getEventDetails was not successful",
            error
          );
        },
        "getEventDetailsV2",
        "1126",
        payload
      );
    },
    newTrip() {
      // New way of communicating to the back-end ---24/01/2020---
      let payload = {};
      if (this.newTripModel == "Empty") {
        payload = {
          EventId: 528,
          ArrivalDate: "31-01-2020",
          ArrivalTime: "11:00",
          GroupSize: 1,
          LanguageTagId: 13
        };
      } else {
        payload = {
          Runtime: this.newTripModel,
          EventId: 528,
          ArrivalDate: "31-01-2020",
          ArrivalTime: "11:00",
          GroupSize: 1,
          LanguageTagId: 13
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for newTrip was successful", response);
          this.tripId = response.data.TripId;
        },
        error => {
          console.log("the call for newTrip was not successful", error);
        },
        "newTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    deleteTrip() {
      // New way of communicating to the back-end ---24/01/2020---
      let payload = {};
      if (this.deleteTripModel == "Empty") {
        payload = {};
      } else {
        payload = {
          Runtime: this.deleteTripModel
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for deleteTrip was successful", response);
          this.tripId = response.data.TripId;
        },
        error => {
          console.log("the call for deleteTrip was not successful", error);
        },
        "deleteTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    cancelOrder() {
      // New way of communicating to the back-end ---24/01/2020---
      let payload = {};
      if (this.cancelOrderModel == "Empty") {
        payload = {};
      } else {
        payload = {
          Runtime: this.cancelOrderModel
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for cancelOrder was successful", response);
          this.tripId = response.data.TripId;
        },
        error => {
          console.log("the call for cancelOrder was not successful", error);
        },
        "cancelOrder",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    finishTrip() {
      // New way of communicating to the back-end ---24/01/2020---
      let payload = {};
      if (this.finishTripModel == "Empty") {
        payload = {};
      } else {
        payload = {
          Runtime: this.finishTripModel
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for finishTrip was successful", response);
          this.tripId = response.data.TripId;
        },
        error => {
          console.log("the call for finishTrip was not successful", error);
        },
        "finishTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getSuggestions() {
      let payload = {};
      if (this.getSuggestionsModel == "Empty") {
        payload = {
          TripId: this.tripId,
          SeqNr: 0,
          GroupSize: 1,
          TagGroup: "Eating",
          Direction: "Forward"
        };
      } else {
        payload = {
          Runtime: this.getSuggestionsModel,
          TripId: this.tripId,
          SeqNr: 0,
          GroupSize: 1,
          TagGroup: "Eating",
          Direction: "Forward"
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getSuggestions was successful", response);
          this.suggestion = response.data.Suggestions;
          console.log("Suggestion: " + this.suggestion);
        },
        error => {
          console.log("the call for getSuggestions was not successful", error);
        },
        "getSuggestions",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    bookActivity() {
      let payload = {};
      if (this.bookActivityModel == "Empty") {
        payload = {
          TripId: this.tripId,
          SeqNr: 1,
          GroupSize: 1,
          EventId: Number(
            this.suggestion[Object.keys(this.suggestion)[0]].EventId
          ),
          Direction: "Forward",
          BookType: 2
        };
      } else {
        payload = {
          Runtime: this.bookActivityModel,
          TripId: this.tripId,
          SeqNr: 1,
          GroupSize: 1,
          EventId: Number(
            this.suggestion[Object.keys(this.suggestion)[0]].EventId
          ),
          Direction: "Forward",
          BookType: 2
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for bookActivity was successful", response);
        },
        error => {
          console.log("the call for bookActivity was not successful", error);
        },
        "bookActivity",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getFullTrip() {
      let payload = {};
      if (this.getFullTripModel == "Empty") {
        payload = {
          TripId: this.tripId
        };
      } else {
        payload = {
          Runtime: this.getFullTripModel,
          TripId: this.tripId
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getFullTrip was successful", response);
        },
        error => {
          console.log("the call for getFullTrip was not successful", error);
        },
        "getFullTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    acceptTrip() {
      let payload = {};
      if (this.acceptTripModel == "Empty") {
        payload = {
          TripId: this.tripId
        };
      } else {
        payload = {
          Runtime: this.acceptTripModel,
          TripId: this.tripId
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for acceptTrip was successful", response);
          this.orderId = response.data.OrderId;
        },
        error => {
          console.log("the call for acceptTrip was not successful", error);
        },
        "acceptTrip",
        "ALP48X6QJ_UG_226",
        payload
      );
    },
    confirmOrder() {
      let payload = {};
      if (this.confirmOrderModel == "Empty") {
        payload = {
          TripId: this.tripId,
          OrderId: this.orderId
        };
      } else {
        payload = {
          Runtime: this.confirmOrderModel,
          TripId: this.tripId,
          OrderId: this.orderId
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for acceptTrip was successful", response);
        },
        error => {
          console.log("the call for acceptTrip was not successful", error);
        },
        "confirmOrder",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getListOfTrips() {
      let payload = {};
      if (this.getListOfTripsModel == "Empty") {
        payload = {};
      } else {
        payload = {
          Runtime: this.getListOfTripsModel
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for getListOfTrips was successful", response);
        },
        error => {
          console.log("the call for getListOfTrips was not successful", error);
        },
        "getListOfTrips",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    arrivedAtEvent() {
      let payload = {};
      if (this.arrivedAtEventModel == "Empty") {
        payload = {
          TripId: this.tripId,
          SeqNr: 1
        };
      } else {
        payload = {
          Runtime: this.arrivedAtEventModel,
          TripId: this.tripId,
          SeqNr: 1
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for acceptTrip was successful", response);
        },
        error => {
          console.log("the call for acceptTrip was not successful", error);
        },
        "arrivedAtEvent",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    leftFromEvent() {
      let payload = {};
      if (this.leftFromEventModel == "Empty") {
        payload = {
          TripId: this.tripId,
          SeqNr: 1
        };
      } else {
        payload = {
          Runtime: this.leftFromEventModel,
          TripId: this.tripId,
          SeqNr: 1
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for acceptTrip was successful", response);
        },
        error => {
          console.log("the call for acceptTrip was not successful", error);
        },
        "leftFromEvent",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    updateLocation() {
      let payload = {};
      if (this.updateLocationModel == "Empty") {
        payload = {
          Latitude: 53.081433 + this.increment,
          Longitude: 4.80685
        };
      } else {
        payload = {
          Runtime: this.updateLocationModel,
          Latitude: 53.081433 + this.increment,
          Longitude: 4.80685
        };
      }
      this.increment += 0.0003;
      console.log("payload for updateLocation", payload);
      dssRequest.doRequest(
        response => {
          console.log("the call for updateLocation was successful", response);
        },
        error => {
          console.log("the call for updateLocation was not successful", error);
        },
        "updateLocation",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    getBookedSuggestions() {
      let payload = {};
      if (this.getBookedSuggestionsModel == "Empty") {
        payload = {
          StartDate: this.startDate,
          EndDate: this.endDate,
          FunctionId: "EventFunctionLibrary::getBookedSuggestions"
        };
      } else {
        payload = {
          Runtime: this.getBookedSuggestionsModel,
          StartDate: this.startDate,
          EndDate: this.endDate,
          FunctionId: "EventFunctionLibrary::getBookedSuggestions"
        };
      }
      console.log("payload", payload);
      dssRequest.doRequest(
        response => {
          this.bookedSuggestions = Number(
            response.data.Suggestions.celldata[0][0]
          );
          console.log(
            "the call for getBookedSuggestions was successful",
            response
          );
        },
        error => {
          console.log(
            "the call for getBookedSuggestions was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.$store.getters["auth/userName"],
        payload
      );
    }
  }
};
</script>

<style>
</style>
